import React from 'react';
import { Link } from 'react-router-dom';
import { useLegalModal } from '../../../contexts/LegalModalContext';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { openLegal } = useLegalModal();

  const legalLinkClass = 'text-sm transition-colors bg-transparent border-0 cursor-pointer p-0';
  const legalLinkStyle: React.CSSProperties = { fontFamily: 'inherit' };

  return (
    <footer style={{ background: 'var(--neutral-900)', color: 'var(--text-inverse)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo ve Hakkımızda */}
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <span className="text-2xl font-bold" style={{ color: 'var(--text-inverse)' }}>MENTEEM</span>
            </div>
            <p className="mb-8 text-sm leading-relaxed" style={{ color: 'var(--neutral-300)' }}>
              Menteem, bilişim alanında mentörlük ve koçluğu yeniden tanımlayan, öğrenciler ile deneyimli profesyonelleri bir araya getiren bir platformdur. Amacımız, mentörlük deneyimini herkes için ulaşılabilir kılmak ve kariyer yolculuklarınızı bilgi ile hızlandırmaktır. Hakkımızda, kullanım koşulları ve gizlilik politikası için aşağıdaki bağlantılara bakın.
            </p>
          </div>

          {/* Menteeler İçin */}
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-6" style={{ color: 'var(--text-inverse)' }}>Menteeler İçin</h3>
            <div className="space-y-3">
              <div>
                <Link to="/mentor-search" className="text-sm underline hover:no-underline transition-all" style={{ color: 'var(--neutral-300)' }} onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-400)'; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--neutral-300)'; }}>
                  Mentör Ara
                </Link>
              </div>
              <div>
                <Link to="/login" className="text-sm underline hover:no-underline transition-all" style={{ color: 'var(--neutral-300)' }} onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-400)'; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--neutral-300)'; }}>
                  Giriş Yap
                </Link>
              </div>
              <div>
                <Link to="/register-mentee" className="text-sm underline hover:no-underline transition-all" style={{ color: 'var(--neutral-300)' }} onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-400)'; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--neutral-300)'; }}>
                  Kayıt Ol
                </Link>
              </div>
            </div>
          </div>

          {/* Mentörler İçin */}
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-6" style={{ color: 'var(--text-inverse)' }}>Mentörler İçin</h3>
            <div className="space-y-3">
              <div>
                <Link to="/login" className="text-sm underline hover:no-underline transition-all" style={{ color: 'var(--neutral-300)' }} onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-400)'; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--neutral-300)'; }}>
                  Giriş Yap
                </Link>
              </div>
              <div>
                <Link to="/register-mentor" className="text-sm underline hover:no-underline transition-all" style={{ color: 'var(--neutral-300)' }} onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-400)'; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--neutral-300)'; }}>
                  Kayıt Ol
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--neutral-700)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm mb-4 md:mb-0" style={{ color: 'var(--neutral-400)' }}>
              © {currentYear} Menteem. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-x-8 gap-y-2 justify-center">
              <button
                type="button"
                className={legalLinkClass}
                style={{ ...legalLinkStyle, color: 'var(--neutral-400)' }}
                onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-400)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--neutral-400)'; }}
                onClick={() => openLegal('about')}
              >
                Hakkımızda
              </button>
              <button
                type="button"
                className={legalLinkClass}
                style={{ ...legalLinkStyle, color: 'var(--neutral-400)' }}
                onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-400)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--neutral-400)'; }}
                onClick={() => openLegal('privacy')}
              >
                Gizlilik Politikası
              </button>
              <button
                type="button"
                className={legalLinkClass}
                style={{ ...legalLinkStyle, color: 'var(--neutral-400)' }}
                onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-400)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--neutral-400)'; }}
                onClick={() => openLegal('terms')}
              >
                Kullanım Koşulları
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
